import { authLoginRequest, authLogoutRequest, authMfaCancel, authMfaSubmit, authRegisterRequest, authResetPasswordRequest } from '@store/slices/auth/authSlice.js';
import { takeLatest } from 'redux-saga/effects';

import { loginRequestSaga, mfaCancelSaga, mfaSubmitSaga } from './login';
import { logoutRequestSaga } from './logout';
import { registerRequestSaga } from './register';
import { resetPasswordRequestSaga } from './resetPassword';

export function* loginRequestWatcher() {
  yield takeLatest(authLoginRequest, loginRequestSaga);
}

export function* mfaSubmitWatcher() {
  yield takeLatest(authMfaSubmit, mfaSubmitSaga);
}

export function* mfaCancelWatcher() {
  yield takeLatest(authMfaCancel, mfaCancelSaga);
}

export function* logoutWatcher() {
  yield takeLatest(authLogoutRequest, logoutRequestSaga);
}

export function* registerWatcher() {
  yield takeLatest(authRegisterRequest, registerRequestSaga);
}
export function* resetPasswordWatcher() {
  yield takeLatest(authResetPasswordRequest, resetPasswordRequestSaga);
}
